import React from "react";
import PanelHead from "../../UI/Panel/PanelHead";
import PanelBody from "../../UI/Panel/PanelBody";
import { TopResultTable } from "../../UI/Advertising/top-result/TopResultTable";

const TopResultPanel = () => {
  return (
    <div>
      <PanelHead title="Search result" />
      <PanelBody content={<TopResultTable />} />
    </div>
  );
};

export default React.memo(TopResultPanel);
